import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'sb-side-menu-action',
  templateUrl: './side-menu-action.component.html',
  styleUrls: ['./side-menu-action.component.scss']
})
export class SideMenuActionComponent implements OnInit {
  @HostBinding('class') class: string = 'side-menu-action';

  constructor() {}

  ngOnInit(): void {}
}
